export interface AnnualEIT106000List {
    row?: string,
    name?: string,
    annual?: string,
    indent?: number,
    rowspan?: number,
    isEdit?: boolean,
    isEdit2?: boolean,
    isEdit3?: boolean,
    isEdit4?: boolean,
    isEdit5?: boolean,
    isEdit6?: boolean,
    type?: string,
    offsetLossFour?: string,
    offsetLossThree?: string,
    offsetLossTwo?: string,
    offsetLossOne?: string,
    offsetLossTotal?: string,
    realOffsetLoss?: string,
    carryOverOffsetLoss?: string,
    offsetLossIncome?: string,
    totalOffsetLoss?: string,
    currentYearOffsetLoss?: string,
    endTitle?: string,
    end?: boolean,

}

let list: AnnualEIT106000List[] = [
    {
        name: "前十季度",
        row: "1",
        annual: "",
        indent: 0,
        offsetLossFour: "",
        offsetLossThree: "",
        offsetLossTwo: "",
        offsetLossOne: "",
        offsetLossTotal: "",
        realOffsetLoss: "",
        carryOverOffsetLoss: "",
        offsetLossIncome: "",
        totalOffsetLoss: "",
        currentYearOffsetLoss: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: true,
        isEdit5: false,
        isEdit6: true,

    },
    {
        name: "前九季度",
        row: "2",
        annual: "",
        indent: 0,
        offsetLossFour: "",
        offsetLossThree: "",
        offsetLossTwo: "",
        offsetLossOne: "",
        offsetLossTotal: "",
        realOffsetLoss: "",
        carryOverOffsetLoss: "",
        offsetLossIncome: "",
        totalOffsetLoss: "",
        currentYearOffsetLoss: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: true,
        isEdit5: false,
    },
    {
        name: "前八年度",
        row: "3",
        annual: "",
        indent: 0,
        offsetLossFour: "",
        offsetLossThree: "",
        offsetLossTwo: "",
        offsetLossOne: "",
        offsetLossTotal: "",
        realOffsetLoss: "",
        carryOverOffsetLoss: "",
        offsetLossIncome: "",
        totalOffsetLoss: "",
        currentYearOffsetLoss: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: true,
        isEdit5: false,
    },
    {
        name: "前七年度",
        row: "4",
        annual: "",
        indent: 0,
        offsetLossFour: "",
        offsetLossThree: "",
        offsetLossTwo: "",
        offsetLossOne: "",
        offsetLossTotal: "",
        realOffsetLoss: "",
        carryOverOffsetLoss: "",
        offsetLossIncome: "",
        totalOffsetLoss: "",
        currentYearOffsetLoss: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: false,
        isEdit4: true,
        isEdit5: false,
    },
    {
        name: "前六年度",
        row: "5",
        annual: "",
        indent: 0,
        offsetLossFour: "",
        offsetLossThree: "",
        offsetLossTwo: "",
        offsetLossOne: "",
        offsetLossTotal: "",
        realOffsetLoss: "",
        carryOverOffsetLoss: "",
        offsetLossIncome: "",
        totalOffsetLoss: "",
        currentYearOffsetLoss: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: false,
        isEdit4: false,
        isEdit5: false,
    },
    {
        name: "前五年度",
        row: "6",
        annual: "",
        indent: 0,
        offsetLossFour: "",
        offsetLossThree: "",
        offsetLossTwo: "",
        offsetLossOne: "",
        offsetLossTotal: "",
        realOffsetLoss: "",
        carryOverOffsetLoss: "",
        offsetLossIncome: "",
        totalOffsetLoss: "",
        currentYearOffsetLoss: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: false,
        isEdit4: false,
        isEdit5: false,
    },
    {
        name: "前四年度",
        row: "7",
        annual: "",
        indent: 0,
        offsetLossFour: "",
        offsetLossThree: "",
        offsetLossTwo: "",
        offsetLossOne: "",
        offsetLossTotal: "",
        realOffsetLoss: "",
        carryOverOffsetLoss: "",
        offsetLossIncome: "",
        totalOffsetLoss: "",
        currentYearOffsetLoss: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: false,
        isEdit4: false,
        isEdit5: false,
    },
    {
        name: "前三年度",
        row: "8",
        annual: "",
        indent: 0,
        offsetLossFour: "",
        offsetLossThree: "",
        offsetLossTwo: "",
        offsetLossOne: "",
        offsetLossTotal: "",
        realOffsetLoss: "",
        carryOverOffsetLoss: "",
        offsetLossIncome: "",
        totalOffsetLoss: "",
        currentYearOffsetLoss: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: false,
        isEdit4: false,
        isEdit5: false,
    },
    {
        name: "前二年度",
        row: "9",
        annual: "",
        indent: 0,
        offsetLossFour: "",
        offsetLossThree: "",
        offsetLossTwo: "",
        offsetLossOne: "",
        offsetLossTotal: "",
        realOffsetLoss: "",
        carryOverOffsetLoss: "",
        offsetLossIncome: "",
        totalOffsetLoss: "",
        currentYearOffsetLoss: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: false,
        isEdit4: false,
        isEdit5: false,
    },
    {
        name: "前一年度",
        row: "10",
        annual: "",
        indent: 0,
        offsetLossFour: "",
        offsetLossThree: "",
        offsetLossTwo: "",
        offsetLossOne: "",
        offsetLossTotal: "",
        realOffsetLoss: "",
        carryOverOffsetLoss: "",
        offsetLossIncome: "",
        totalOffsetLoss: "",
        currentYearOffsetLoss: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: false,
        isEdit4: false,
        isEdit5: false,
    },
    {
        name: "本年度",
        row: "11",
        annual: "",
        indent: 0,
        offsetLossFour: "",
        offsetLossThree: "",
        offsetLossTwo: "",
        offsetLossOne: "",
        offsetLossTotal: "",
        realOffsetLoss: "",
        carryOverOffsetLoss: "",
        offsetLossIncome: "",
        totalOffsetLoss: "",
        currentYearOffsetLoss: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: false,
        isEdit4: false,
        isEdit5: false,
    },
    {
        endTitle: "可结转以后年度弥补的亏损额合计",
        row: "12",
        indent: 0,
        currentYearOffsetLoss: "",
        end: true,
    },

]


let AnnualEIT106000 = list
export default AnnualEIT106000
